<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Chaduneli.com',
    // all titles will be injected into this template
    titleTemplate: '%s | Chaduneli.com'
  },
}
</script>

<style lang="scss">
@import '../sass/blank';
</style>
